import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

const NotFound = ({ isDarkTheme, error }) => {
  return (
    <div className="px-5 py-5 flex justify-center content-center flex-wrap mt-40 text-6xl error-container">
      <p
        className={classNames(
          'font-sans',
          { 'text-gray-900': !isDarkTheme },
          { 'text-white': isDarkTheme },
        )}
      >
        {error ? 'Something went wrong please try again!!!' : 'Not Found'}
      </p>
    </div>
  );
};

NotFound.propTypes = {
  isDarkTheme: PropTypes.bool,
  error: PropTypes.bool,
};

export default NotFound;
